import { combineReducers, Reducer } from 'redux';
import { ISessionTranscriptPageAction, ISessionTranscriptPageState } from './transcripts.types';
import { isActionOfType } from '../../../utils/action.utils';
import * as types from './transcripts.types';
import * as constants from './transcripts.constants';

const initialState: ISessionTranscriptPageState = {
  sessionTranscripts: {},
};

const sessionTranscriptReducer: Reducer<
  ISessionTranscriptPageState['sessionTranscripts'],
  types.IStoreSessionTranscript | types.IClearSessionTranscript
> = (state = initialState.sessionTranscripts, action) => {
  if (isActionOfType<types.IStoreSessionTranscript>(action, constants.STORE_SESSION_TRANSCRIPT)) {
    return action.payload;
  } else if (isActionOfType<types.IClearSessionTranscript>(action, constants.CLEAR_SESSION_TRANSCRIPT)) {
    return initialState.sessionTranscripts;
  }

  return state;
};

export const sessionTranscriptPageReducer: Reducer<
  ISessionTranscriptPageState,
  ISessionTranscriptPageAction
> = combineReducers({
  sessionTranscripts: sessionTranscriptReducer,
});
